var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector42(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 403,
    viewBox: "0 0 212 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.365 401.127C185.512 374.596 181.76 369.049 167.251 343.351C163.696 337.056 158.395 325.04 153.763 310.466C152.374 306.104 151.163 301.801 150.092 297.576C142.462 267.345 145.277 235.056 152.371 203.767C170.474 123.932 136.87 44.9416 73.61 14.4886C10.2412 -16.0142 -68.276 8.78338 -111.806 58.4512C-117.47 64.914 -142.757 95.6107 -150.92 132.009C-176.726 246.928 -70.5604 309.026 95.9094 367.999C99.148 369.144 114.657 373.95 117.96 374.883L210.375 401.14L210.365 401.127Z",
    stroke: "#E1E3E9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector42);
export default __webpack_public_path__ + "static/media/vector4-2.df846237c3578ac90c2f1d8ea13104e9.svg";
export { ForwardRef as ReactComponent };